import { tokenKey } from 'src/domain/models/token-key';

export const getToken = () => globalThis.localStorage.getItem(tokenKey);

export const setToken = (token: string) => globalThis.localStorage.setItem(tokenKey, token);

export const removeToken = () => globalThis.localStorage.removeItem(tokenKey);

export const removeMsalToken = () => {
    Object.keys(globalThis.sessionStorage).forEach((key) => {
        if (key.indexOf('-login.windows.net-accesstoken-') > 0) {
            globalThis.sessionStorage.removeItem(key);
        }
    });
};
